(function () {
    function loadZendeskChat(callback) {
        let zdscript = document.createElement('script');
        zdscript.setAttribute('id','ze-snippet');
        zdscript.src = 'https://static.zdassets.com/ekr/snippet.js?key=6d287210-f99e-4221-aac0-9e96e46c0006';
        (document.getElementsByTagName('body')[0]).appendChild(zdscript);

        window.zdonload = setInterval(function(){
        if(typeof zE !== "undefined" && typeof zE.activate !== "undefined") {
            clearInterval(window.zdonload);
            callback();
        }
        },50,null)
    };

    window.loadAndOpenZendeskChat = function() {
        let button = document.getElementById('zdbutton');
        button.innerHTML = 'Loading...';
        loadZendeskChat(function(){
        window.setTimeout(function(){
            zE.activate();
            button.parentNode.removeChild(button);
        },1000);
        });
    }
}());